import axios from "axios";
export interface SaveDraftPayload {
  doctorId: number;
  namePrefixCode:string;
  userId: string|null;
  userIp: string;
  locationId: number;
  locationName: string;
  doctorName: string;
  designation: string;
  specializationId: number | null;
  experienceYears: number;
  doctorFees: number;
  languages: string;
  EmpCode:string;
  source:string;
  imagePath:string;
  qualification: string;
  professionalSummary: string;
  awardsAchievements: string[];
  researchPublications: string[];
  previousExperiance: Array<{
    role: string;
    description: string;
  }>;
  areaOfInterest: Array<{
    role: string;
    description: string;
  }>;
  status: string;
  feedback: string;
  Remark:string;
  Event:string;
   gender: string;
    phoneNo: string;
    emailId: string;
    registrationNo: string;
    secondaryLocations: {
    locationId: number;
  }[];
   
}



export const saveDraftAndReviewAPI = async (payload: SaveDraftPayload,doctorId:number) => {
  return axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/Marketing/savedraftandreview`,
    payload
  );
};

export const createNewDoctor = async (payload: any) => {
  return axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/Marketing/adddoctor`,
    payload
  );
};
export const uploadDoctorImage = async (payload: any) => {
  return axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/Marketing/uploadimage`,
    payload
  );
};



export const handleApproveReject = async (data: SaveDraftPayload)=>{
  return axios.post(`${process.env.REACT_APP_BASE_URL}/api/Marketing/approvedreject`, data);
};

export const getAllDoctorsAPI = async (roleName: string | null) => {
  return axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/Marketing/getalldoctors`,
    {
      params: {
        Role: roleName,
        Remark:"Get all Doctor List",
        Event:"Doctor list"
      }
    }
  );
};

export const getDoctorByIdAPI = async (doctorId:number,userId:string) => {
  return axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/Marketing/getdoctorsbyid`,
    {
      params: { doctorId: doctorId,Remark:"Viewed the Doctor Profile",UserId:userId, Event:"Doctor Profile" } 
    }
  );
};

export const UpdateActivateDeactivateDoctor = async (payload: any) => {
  return axios.patch(
    `${process.env.REACT_APP_BASE_URL}/api/Marketing/activedeactive`, {},
   {
    params:payload
   }
  );
};


export const getDoctorTATAPI = (
  doctorId: number,
  remark: string,
  userId: number,
  Event:string
) => {
  return axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/Marketing/statustimestamp`,
    {
      params: {
        doctId: doctorId,
        remark: remark,
        userId: userId,
        Event:Event
      }
    }
  );
};





